module.exports = __webpack_public_path__ + "static/media/hkust.5441918e.png";